import AuthToken from "./authtoken";

export default function(url, options) {
  // add bearer token to the headers if we have one
  var authHeader = AuthToken.getAuthHeader();
  
  if(authHeader) {
    if(!options)
      options = {};
    
    if(!options.headers)
      options.headers = new Headers();
    
    options.headers.set("Authorization", authHeader);
  }
  
  return fetch(url, options);
}



// WEBPACK FOOTER //
// ./src/api/authfetch.js